// extracted by mini-css-extract-plugin
export default {"container":"dispensary-menu_container__y47aU","main":"dispensary-menu_main__DlzCm","title":"dispensary-menu_title__LfSKM","grid":"dispensary-menu_grid__SPNhq"};